/* eslint-disable */
import { ReactComponent as AddStudent } from './add-student.svg';
import { ReactComponent as ArrowRight } from './arrow-right.svg';
import { ReactComponent as Back } from './back.svg';
import { ReactComponent as Card } from './card.svg';
import { ReactComponent as Cart } from './cart.svg';
import { ReactComponent as Close } from './close.svg';
import { ReactComponent as Delete } from './delete.svg';
import { ReactComponent as Edit } from './edit.svg';
import { ReactComponent as Eye } from './eye.svg';
import { ReactComponent as EyeInvisible } from './eye-invisible.svg';
import { ReactComponent as Facebook } from './facebook.svg';
import { ReactComponent as Google } from './google.svg';
import { ReactComponent as Gift } from './gift.svg';
import { ReactComponent as IconDown } from './icon-down.svg';
import { ReactComponent as IconUp } from './icon-up.svg';
import { ReactComponent as Info } from './info.svg';
import { ReactComponent as Invite } from './invite.svg';
import { ReactComponent as InviteShadow } from './invite-shadow.svg';
import { ReactComponent as Repeat } from './repeat.svg';
import { ReactComponent as Logout } from './logout.svg';
import { ReactComponent as Map } from './map.svg';
import { ReactComponent as More } from './more.svg';
import { ReactComponent as MoveLeft } from './move-left.svg';
import { ReactComponent as MoveRight } from './move-right.svg';
import { ReactComponent as Next } from './next.svg';
import { ReactComponent as Note } from './note.svg';
import { ReactComponent as Pause } from './pause.svg';
import { ReactComponent as Play } from './play.svg';
import { ReactComponent as Questionmark } from './questionmark.svg';
import { ReactComponent as Reward } from './reward.svg';
import { ReactComponent as Redo } from './redo.svg';
import { ReactComponent as Settings } from './settings.svg';
import { ReactComponent as Shop } from './shop.svg';
import { ReactComponent as Sound } from './sound.svg';
import { ReactComponent as SoundSelection } from './sound-selection.svg';
import { ReactComponent as Statistic } from './statistic.svg';
import { ReactComponent as Student } from './student.svg';
import { ReactComponent as Check } from './check.svg';
import { ReactComponent as User } from './user.svg';
import { ReactComponent as Exclamation } from './exclamation.svg';
import { ReactComponent as YellowStar } from './yellow-star.svg';
import { ReactComponent as Wardrobe } from './wardrobe.svg';
import { ReactComponent as GreenStar } from './green-star.svg';
import { ReactComponent as Archive } from './archive.svg';
import { ReactComponent as Save } from './save.svg';
import { ReactComponent as ThreeDots } from './3dots.svg';
import { ReactComponent as US } from 'flag-icons/flags/4x3/us.svg';
import { ReactComponent as UK } from 'flag-icons/flags/4x3/gb.svg';
import { ReactComponent as HR } from 'flag-icons/flags/4x3/hr.svg';
import { ReactComponent as PL } from 'flag-icons/flags/4x3/pl.svg';

export default {
  addStudent: AddStudent,
  'arrow-right': ArrowRight,
  back: Back,
  card: Card,
  cart: Cart,
  close: Close,
  delete: Delete,
  edit: Edit,
  eye: Eye,
  'eye-invisible': EyeInvisible,
  facebook: Facebook,
  google: Google,
  gift: Gift,
  'icon-down': IconDown,
  'icon-up': IconUp,
  info: Info,
  invite: Invite,
  inviteShadow: InviteShadow,
  repeat: Repeat,
  logout: Logout,
  map: Map,
  more: More,
  'move-left': MoveLeft,
  'move-right': MoveRight,
  next: Next,
  note: Note,
  pause: Pause,
  play: Play,
  questionmark: Questionmark,
  reward: Reward,
  redo: Redo,
  settings: Settings,
  shop: Shop,
  sound: Sound,
  'sound-selection': SoundSelection,
  statistic: Statistic,
  student: Student,
  check: Check,
  user: User,
  exclamation: Exclamation,
  'yellow-star': YellowStar,
  wardrobe: Wardrobe,
  'green-star': GreenStar,
  archive: Archive,
  save: Save,
  threeDots: ThreeDots,
  us: US,
  uk: UK,
  hr: HR,
  pl: PL,
};
